import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const P = ({ children }) => (
  <p className="text-[15px] leading-[1.75] text-[var(--ink2)] mt-4">{children}</p>
);

export default function Refunds() {
  return (
    <div data-testid="refunds-page" className="min-h-screen bg-[var(--paper)] text-[var(--ink)]">
      <Navbar />
      <main className="max-w-[720px] mx-auto px-6 sm:px-10 py-24">
        <span className="eyebrow">◆ Legal</span>
        <h1 className="h-display text-[44px] sm:text-[56px] mt-3 leading-[1.05]">Cancellation &amp; Refund Policy</h1>
        <p className="mono text-[11px] tracking-[0.18em] uppercase text-[var(--ink3)] mt-6">
          Last updated · August 1, 2026
        </p>

        <P>
          All purchases made on Nirno are final. Nirno sells digital travel itineraries and curated travel experiences that are delivered and accessible immediately upon purchase. For this reason, we do not offer refunds, returns, or cancellations once a purchase is completed.
        </P>
        <P>
          Every itinerary and experience includes a free Day 1 preview so you can review the creator&rsquo;s style and quality before you buy. We encourage you to use this preview to make an informed decision.
        </P>
        <P>
          If you face a technical issue accessing a purchased itinerary or experience, please contact us and we will help resolve it.
        </P>
        <P>
          For any billing inquiries, contact us at <a href="mailto:hello@nirno.co.in" className="underline hover:text-[var(--red)]">hello@nirno.co.in</a>.
        </P>
      </main>
      <Footer />
    </div>
  );
}
